import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae8e04ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stock-left" }
const _hoisted_2 = { class: "stock-right" }
const _hoisted_3 = { style: {"font-size":"20px","font-weight":"500"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "stock-info-card",
    style: _normalizeStyle({ background: _ctx.isDark ? '#181818' : '#f0f2f5' })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "stock-name",
        style: _normalizeStyle({ color: _ctx.isDark ? '#fff' : '#1a1a1a' })
      }, _toDisplayString(_ctx.name || '--'), 5),
      _createElementVNode("div", {
        class: "stock-code",
        style: _normalizeStyle({ color: _ctx.isDark ? 'rgba(255,255,255,0.45)' : '#999' })
      }, _toDisplayString(_ctx.symbol || '--'), 5)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.colorClass)
      }, [
        _createElementVNode("strong", _hoisted_3, _toDisplayString(_ctx.displayPrice), 1)
      ], 2),
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.colorClass)
      }, _toDisplayString(_ctx.displayChange), 3),
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.colorClass)
      }, _toDisplayString(_ctx.displayRate), 3)
    ])
  ], 4))
}